<template>
  <section>
    <v-col class="ring pa-0">
      <elwrapper label="Rate" smlabel texttop>
        <SeasonalPricing
          v-if="seasonal"
          :env="env"
          :disabled="!editable"
          v-model="rate"
          @revert="toggleSeasonal(false)"
        />

        <div v-else>
          <div>
            <div class="d-flex align-center">
              <div style="max-width: 300px; margin-right: 8px">
                <cur-per-val :env="env" :dropdown="source" :default="defaultPer" v-model="rate" :disabled="!editable" />
              </div>
              <g-button
                v-if="rate.type == 'PROOM'"
                label="Generate Prices"
                icon="add"
                @onclick="generateFlatPrice"
                :disabled="hasFlatPricePerRoomData"
              />
            </div>
          </div>
          <span v-show="editable" class="seasonal-click blue--text caption pr-3" @click="toggleSeasonal(true)"
            >Change to Seasonal</span
          >
        </div>
      </elwrapper>
      <div class="d-flex align-center" style="margin-left: 50px">
        <div class="d-flex align-center">
          <input type="radio" name="rateKind" value="GENERIC" v-model="rate_kind" :disabled="!editable" />
          <span class="caption mx-2">Generic</span>
        </div>
        <div class="d-flex align-center">
          <input type="radio" name="rateKind" value="CONTRACT" v-model="rate_kind" :disabled="!editable" />
          <span class="caption mx-2">Contracted</span>
        </div>
      </div>
    </v-col>
    <v-col class="ring pa-0" v-if="rate.type === 'PROOM'">
      <div v-for="(data, i) in perRoomData" :key="data.type + i">
        <v-row class="align-center">
          <elwrapper label="Rate" texttop style="max-width: 350px">
            <cur-per-val
              :env="env"
              :dropdown="perRoomTypeSource"
              :default="defaultPerRoom"
              v-model="perRoomData[i]"
              :disabled="!editable"
            />
          </elwrapper>
          <v-btn x-small icon class="select-clear" @click="() => removePerRoomDataRow(i)">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-row>
      </div>
      <g-button label="Add a new rate" icon="add" @onclick="addPerRoomDataRow" />
    </v-col>
  </section>
</template>

<script>
import moneyService from "@/services/money";
import { ProductFields, ProductPerRoomTypes } from "@/config/fields/products";
import SeasonalPricing from "./_SeasonalPricing";
export default {
  props: {
    supplierName: String,
    customYear: String,
  },
  components: {
    SeasonalPricing,
  },
  // watch: {
  //   rate(value) {
  //     if (value.type === "PROOM" && this.perRoomData.length === 0) {
  //       this.addPerRoomDataRow();
  //     }
  //   },
  // },
  computed: {
    editable() {
      const currentYear = new Date().getFullYear();
      if (this.defaultEnv) {
        if (`${currentYear}` === this.customYear) return true;
        if (`${currentYear + 1}` === this.customYear) return true;
        if (`${currentYear + 2}` === this.customYear) return true;
      }
      return false;
    },

    env() {
      return this.$store.getters["AccountStore/environment"];
    },
    source() {
      const productType = this.get("type");
      const supplierType = this.get("supplier_type");
      const sources = ProductFields.rate_type
        .getSource(productType, supplierType)
        .map((opt) => (opt.value === "PROOM" ? { ...opt, label: `${opt.label} (Double)` } : opt));
      return sources;
    },
    rate: {
      get() {
        return this.$store.getters["ProductStore/rate"](this.customYear);
      },
      set(newValue) {
        return this.setByRate("rate", newValue);
      },
    },
    seasonal: {
      get() {
        return this.getByRate("seasonal");
      },
      set(newValue) {
        return this.setByRate("seasonal", newValue);
      },
    },
    rate_kind: {
      get() {
        return this.getByRate("meta").rate_kind;
      },
      set(newValue) {
        return this.$store.dispatch("ProductStore/setUpdateMeta", {
          key: "rate_kind",
          value: newValue,
          year: this.customYear,
        });
      },
    },
    defaultPer() {
      var productType = this.get("type");
      var supplierType = this.get("supplier_type");

      if (productType === "ROOM") return "PROOM";
      if (["MEAL", "EXCURSION"].includes(productType)) return "PP";
      if (["RESTAURANT", "EXCURSION"].includes(supplierType)) return "PP";
      if (supplierType === "TRANSPORT") return "PG";
      return "";
    },
    defaultEnv() {
      return this.get("supplier_env") == this.$store.getters["AccountStore/environment"];
    },
    perRoomTypeSource() {
      return Object.values(ProductPerRoomTypes).filter((roomType) => !roomType.value.includes("DOUBLE_QK"));
    },
    defaultPerRoom() {
      return ProductPerRoomTypes.SINGLE.value;
    },
    perRoomData: {
      get() {
        return this.getByRate("meta").per_room ?? [];
      },
      set(newValue) {
        return this.$store.dispatch("ProductStore/setUpdateMeta", {
          key: "per_room",
          value: newValue,
          year: this.customYear,
        });
      },
    },
    hasFlatPricePerRoomData() {
      return this.perRoomData.length > 0;
    },
  },
  methods: {
    get(val) {
      return this.$store.getters["ProductStore/" + val];
    },
    getByRate(val) {
      return this.$store.getters["ProductStore/" + val](this.customYear);
    },
    set(key, val) {
      return this.$store.dispatch("ProductStore/setUpdate", { key, val });
    },
    setByRate(key, val) {
      return this.$store.dispatch("ProductStore/setUpdateRate", { key, val, year: this.customYear });
    },
    toggleSeasonal(on) {
      // Turn it on here
      if (on) {
        const isProom = this.rate.type === "PROOM";
        const roomType = isProom ? "DOUBLE_QK" : "DEFAULT";
        this.rate = [
          {
            dstart: 1,
            dend: 31,
            mstart: 1,
            mend: 12,
            rate: this.rate,
            roomType: roomType,
          },
        ];
        this.seasonal = true;
        return;
      }

      // Switch from seasonal view back to regular
      this.seasonal = false;
      if (this.rate.length === 0) {
        this.rate = {
          ...(this.defaultPer && { type: this.defaultPer }),
        };
        return;
      }

      // Existing seasonal price
      this.rate = this.rate[0].rate;
    },
    addPerRoomDataRow() {
      this.perRoomData = [...this.perRoomData, { type: ProductPerRoomTypes.SINGLE.value, value: "", cur: this.env }];
    },
    removePerRoomDataRow(index) {
      this.perRoomData = this.perRoomData.filter((_, i) => i !== index);
    },
    getAdditionalPrice(environment, roomType) {
      const priceModifiers = {
        USA: { SINGLE_DK: 0, TRIPLE: 20, DOUBLE_DOUBLE: 20, QUAD: 40 },
        CDA: { SINGLE_DK: 0, TRIPLE: 20, QUAD: 40 },
      };
      return priceModifiers[environment]?.[roomType] || 0;
    },
    generateFlatPrice() {
      const basePrice = this.rate.value ? moneyService.stripFormatting(this.rate.value) : 0;
      const roomTypes = [
        ProductPerRoomTypes.SINGLE.value,
        ProductPerRoomTypes.TWIN.value,
        ProductPerRoomTypes.TRIPLE.value,
        ProductPerRoomTypes.QUAD.value,
      ];

      this.perRoomData = roomTypes.map((roomType) => ({
        type: roomType,
        value: basePrice + this.getAdditionalPrice(this.env, roomType),
        cur: this.env,
      }));
    },
  },
};
</script>

<style lang="scss">
.seasonal-click:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
